const isDevEnvironment = NODE_ENV === "development";
const EXCEPTION_LEVEL = {
  ERROR: "error",
  WARNING: "warning",
  INFO: "info"
};
/**
 * Send error to sentry
 */

const throwError = ({
  error,
  code,
  message,
  level = EXCEPTION_LEVEL.ERROR,
  properties
}) => {
  let err;

  if (error && error instanceof Error) {
    err = error;
  } else {
    err = new Error(message); // $FlowFixMe

    err.code = code;
  } // Check Raven(sentry) init


  const isSentryInit = typeof Raven === "object" && Raven.captureMessage;

  if (Error.captureStackTrace) {
    Error.captureStackTrace(err, throwError);
  }

  if (isDevEnvironment || !isSentryInit) {
    if (level === EXCEPTION_LEVEL.ERROR) {
      throw err;
    }

    if (level === EXCEPTION_LEVEL.WARNING) {
      // eslint-disable-next-line no-console
      console.warn(err, {
        code,
        message,
        level,
        properties
      });
      return;
    } // eslint-disable-next-line no-console


    console[level](err, {
      code,
      message,
      level,
      properties
    });
    return;
  }

  const exceptionInfo = {
    level
  };

  if (message) {
    exceptionInfo.message = message;
  }

  if (properties) {
    exceptionInfo.extra = {
      properties
    };
  }

  if (level === EXCEPTION_LEVEL.INFO) {
    Raven.captureMessage(message || "", exceptionInfo);
    return;
  }

  Raven.captureException(err, exceptionInfo);
};
/**
 * Send warning to sentry
 */


const throwWarning = (options, ...rest) => throwError({ ...options,
  level: EXCEPTION_LEVEL.WARNING
}, ...rest);
/**
 * Send info to sentry
 */


const throwInfo = (options, ...rest) => throwError({ ...options,
  level: EXCEPTION_LEVEL.INFO
}, ...rest);

export { EXCEPTION_LEVEL, throwError, throwWarning, throwInfo };